module.exports = __webpack_public_path__ + "img/z (30).96793ca6.png";